const unauthorizedMessage = 'The credentials you entered are invalid.'

const errorCodes = {
  CompromisedPassword:
    'The password you entered is known to have been exposed in data breaches',
  WeakPassword: `The password you entered does not pass our security requests.
  Please add more characters and try again.`,
  NotVerified:
    'The account is not verified. We just sent you a verification email.',
  InvalidCredentials: unauthorizedMessage,
  Unauthorized: unauthorizedMessage,
  Timeout: 'Session timed out',
  NotFound: 'The resource does not exist',
  InvalidInput: 'The data you entered is invalid',
  UserVerified: 'The user is already verified',
  UserNotFound: 'The email address you entered is not a valid account',
  EmailTaken: 'The email address you entered, is already taken.',
  AmountZero: 'An invoice with amount 0 could not be paid.',
  EmailNotWhitelisted:
    'The email you entered is not allowed for private beta. Please contact us if you want to be participate in our beta.'
}

const getError = code => errorCodes[code] || null

export default getError
